export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export function parseDateOnly (value) {
  if (!value) return null

  if (value instanceof Date) return value

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  }

  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatDateOnly (value, separator = '-') {
  const date = parseDateOnly(value)
  if (!date) return '-'

  return `${String(date.getDate()).padStart(2, '0')}${separator}${String(
    date.getMonth() + 1
  ).padStart(2, '0')}${separator}${date.getFullYear()}`
}

export async function fetchKategoriPengeluaran () {
  try {
    const axios = (await import('axios')).default
    const res = await axios.get('master-data?kategori=kategori_pengeluaran')
    return res.data.map(k => k.nama)
  } catch (e) {
    console.error('Gagal memuat kategori pengeluaran', e)
    return []
  }
}

export async function fetchMasterPenagih () {
  try {
    const axios = (await import('axios')).default
    const res = await axios.get('master-data?kategori=penagih')
    return res.data
  } catch (e) {
    console.error('Gagal memuat master penagih', e)
    return []
  }
}

